import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrafficAnalysisSection from './components/TrafficAnalysisSection';
import NewPortSection from './components/NewPortSection';
import MarketStabilitySection from './components/MarketStabilitySection';
import InfrastructureOverviewSection from './components/InfrastructureOverviewSection';
import EntryStrategySection from './components/EntryStrategySection';
import ConclusionSection from './components/ConclusionSection';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <TrafficAnalysisSection />
      <NewPortSection />
      <MarketStabilitySection />
      <InfrastructureOverviewSection />
      <EntryStrategySection />
      <ConclusionSection />
    </div>
  );
}
